import * as R from "ramda";
import { createHandlers } from "redux-mvc";
import {
  NAMESPACE,
  TAB_IDS
  // LOCATION_TYPE_IDS
} from "./constants";

const iniState = {
  data: {},
  updatedFieldValues: {},
  saving: false,
  loading: false,
  isEditingSession: false,
  isEditingSub: false,
  sessionData: {
    required_field_ids: [],
    locked_field_ids: [],
    fields: []
  },
  contentSettings: {},
  fromHomePage: false,
  showEmptyState: false,
  showNoResults: false,
  selectedTab: TAB_IDS.DETAILS,
  sessionDataInEdition: {},
  subDataInEdition: {},
  contactDataInUse: {},
  hasUnSavedChangesModal: false,
  transitionToTabIdAfterSave: null,
  fieldsErrorMessage: null
};

const model = createHandlers({
  iniState,
  reducers: {
    init: R.identity,
    refreshData: R.identity,
    //
    save: R.identity,
    cancel: R.identity,
    onCancelUnsavedChanges: R.identity,
    onConfirmUnsavedChanges: R.identity,
    //
    enableSessionEditMode: R.identity,
    disableContactEditMode: R.identity,
    search: R.identity,
    closeSessionFlyover: R.identity,
    onOpen: R.identity,
    viewMore: R.identity,
    openSessionFlyover: R.identity,
    openSession: R.identity,
    setInitialData: (_, { payload: { sessionData, contentSettings } }) => ({
      sessionData,
      contentSettings
    }),
    showUploadFilePicker: R.identity,
    resetData: R.always(iniState),
    resetDataOnInit: () => ({
      ...iniState,
      hasChanges: false,
      showSessionModal: true,
      loading: true,
      saving: false
    }),
    setUpdatedFieldValue: (state, { payload: { fieldId, value } }) => ({
      updatedFieldValues: {
        ...state.updatedFieldValues,
        [fieldId]: value
      }
    }),
    setEditSessionInitialData: ({ sessionData }, { payload: {} }) => {
      return {
        data: sessionData.fields.reduce((a, b) => {
          a[b.id] = b.editable_value;
          return a;
        }, {}),
        editingSessionLoadedAt: new Date()
      };
    }
  },
  namespace: NAMESPACE
});

const { actions, getters } = model;

export { actions, getters };

export default model;
